var lib_core = require("lib-core");

var TrayView = function(model, stateMachine, parentView, masterView, toggleButton, rootStateMachine, editorModel, configuration) {
    var self = this;

    this.parentView = parentView;
    this.masterView = masterView;
    this.rootStateMachine = rootStateMachine;
    this.stateMachine = stateMachine;
    this.model = model;
    this.editorModel = editorModel;
    this.toggleButton = toggleButton;
    this.configuration = configuration;
    this.tabs = [];

    // Set Default Height
    this.getTemplate().setHeight(this.model.height());

    // Set hidden by default
    if(!this.model.initial_show)
        this.hide();

    // EVENT LISTENERS
    this.getTemplate().$el.on('Cioui:Tray:Drag:MouseDown', function(e, event){

        var mouseCoord = self.editorModel.getRelativeMouseCoord(event);

        var cEvent = new lib_core.GuiEvent()
            .type(lib_core.GuiEvents.UI_TRAY_DRAG_MOUSE_DOWN)
            .data('mouseCoord', mouseCoord)
            .scope(self.model.scope());

        return self.stateMachine.handle(cEvent);
    });

    // OBSERVERS
    this.model.height.onChange('heightOnChange', function(value){
        if(value > self.model.minimum_height){ // set minimum height
            self.getTemplate().setHeight(value);
        }
    }, 10);

    this.model.visible.onChange('visibleOnChange', function(value){
        if(value){
            self.show();
        }else{
            self.hide();
        }
    }, 10);

    if(this.masterView && this.masterView.model.wizardMode()) {
        if(this.toggleButton) {
            this.toggleButton.hide();
        }
    } else {
        if(this.toggleButton) {
            this.toggleButton.show();
        }
    }

    this.masterView && this.masterView.model.wizardMode.onChange(this, function(mode) {
        if(!mode) {
            if(self.toggleButton) {
                self.toggleButton.show();
            }
        }
    });
};

module.exports = TrayView;

TrayView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = this.parentView.getTemplate().addTray(this.model.initial_show);
    }
    return this._template;
};

TrayView.prototype.show = function (completeCallBack) {
    this.getTemplate().show();
    this.getTemplate().setHeight(this.model.height());
    if(this.toggleButton){
        this.toggleButton.setActive();
    }
};

TrayView.prototype.hide = function () {
    this.getTemplate().hide();
    if(this.toggleButton){
        this.toggleButton.setInActive();
    }
};
